import React from 'react';
// eslint-disable-next-line react/prop-types
export default ({ children, ...rest }) => <button {...rest}>{children}</button>;